// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-jax
// Generated: 2026-10-01T17:23:36.435Z
// Counts: 3 design, 83 content, 24 slot group, 6 collection binding, 9 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Designed for Comfort, Connection, and Community.</h2><h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome Home to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at The Jax puts you close to everything that makes Monroe such a great place to call home.</p><p>Spend weekends exploring charming downtown Monroe, enjoy nearby parks and recreation, discover local restaurants and coffee shops, or take advantage of convenient access to shopping, schools, and major employers. Wherever the day takes you, you're never far from home.</p><p>Monroe Museum, Crispell Park, and educational hubs such as Athens Technical College provide a lot to offer. Dive into an active lifestyle with nearby fitness centers and parks!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Monroe step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to The Jax</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019df439-e65b-7138-850b-1a84f10799ea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>The best communities make everyday life easier.</strong></p><p>From resort-style spaces to convenient everyday features, The Jax was thoughtfully designed to help you relax, connect, and enjoy every moment at home. Our apartments in Monroe, GA, offer a resort-style swimming pool, a state-of-the-art fitness center, and a vibrant dog park. Your ideal lifestyle awaits—come see what makes us unique!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>We'd Love to Welcome You Home</strong></span></h2><p>Whether you're ready to move soon or just beginning your apartment search, our leasing team is here to answer your questions and help you find the perfect apartment home.</p><p>Our dedicated leasing team is ready to assist you with any inquiries you may have.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Space</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Life Looks Better Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>Make Yourself At Home</strong></span></p><p>Whether you're looking for your first apartment or simply more room to grow, The Jax offers spacious layouts designed to fit your lifestyle. Explore our available floor plans and find the home that feels just right.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>See Yourself at The Jax</strong></span></h2><p>Browse our gallery and imagine relaxing poolside, enjoying your beautifully designed apartment, or coming home to a community you'll be proud to call your own.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>Enjoy Everything Monroe Has to Offer</strong></span></h2><p>Life at The Jax puts you close to everything that makes Monroe a great place to call home.</p><p>Spend weekends exploring charming downtown Monroe, enjoy nearby parks and recreation, discover local restaurants and coffee shops, or take advantage of convenient access to shopping, schools, and major employers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>We Love Pets!</strong></span></p><p>At The Jax, we believe your pets deserve to feel at home just as much as you do. Our pet-friendly <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">apartments in Monroe, GA</a>, accommodate up to two pets per home, providing ample space and amenities for your furry companions. From on-site pet washing stations to a playful dog park, our community embraces pet ownership with convenience and care. Please feel free to contact us for full details regarding pet fees, monthly rent, and any additional questions you may have.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life feels a little different when home is designed around the way you live.</p><p>At The Jax, you'll discover spacious one, two, and three-bedroom apartment homes that combine modern style with everyday comfort. Bright open-concept layouts, nine-foot ceilings, granite countertops, stainless steel appliances, and generous walk-in closets create a home that's both beautiful and functional.</p><p>Outside your front door, every day brings new opportunities to relax and recharge. Spend sunny afternoons beside the resort-style pool, fire up the grill with friends, challenge neighbors to a game of sand volleyball, or fit in a workout whenever it works for your schedule in the 24-hour fitness center.</p><p>Whether you're working from home, commuting around Monroe, or simply enjoying everything the area has to offer, The Jax provides the comfort, convenience, and welcoming atmosphere you've been searching for.</p><p><strong>Schedule your tour today and experience The Jax for yourself.</strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Jax in Monroe, GA, where comfort meets convenience. Choose from our stylish one, two, or three-bedroom floor plans tailored to your lifestyle. We offer <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">apartments</a> for rent in Monroe, GA, with online rent payment via the Resident Portal. You can also schedule maintenance and unlock a world of <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">amenities</a> designed just for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Jax in Monroe, GA, choose from <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">cozy one-bedroom retreats to spacious three-bedroom designs</a>, perfectly tailored for every lifestyle. Embrace the community spirit that sets us apart. Schedule a tour today of our apartments near Piedmont Walton Hospital, and hear firsthand how our residents love calling The Jax home! Your next chapter starts here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>Ready to envision your new home?</strong></span></p><p>Experience vibrant living spaces tailored to your lifestyle. </p><p>Take a virtual tour today and see all that our community has to offer!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-5ae5-7592-9627-58b9e58166c9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered outdoor kitchen with grills and televisions"
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-1b94-73d1-9af1-7f92346e65f1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings, a central clubhouse, and surrounding landscaping."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-1d45-7007-9a2f-91a7e502f568.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, granite countertops, and island seating."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": 7,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019faa86-90c9-73bf-8a6f-81413c631339.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man enjoying a sunny day walking his Labrador dog in a peaceful park setting."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[9].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[9].poi_featured_image_media.alt_text"
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-41e0-771f-8acd-bfdd21b362f1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a tan leather sofa, coffee table, and decorative art."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-b3f1-72d7-b20d-6a530d622a3c.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-44c0-76cc-be9f-32ce221cb300.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-07c8-7359-b3d3-c235a745b221.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-973b-74ca-8c54-10be6edf4e04.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern lounge area with comfortable seating, artwork, and large windows overlooking the pool."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 32,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-c711-77d9-9ceb-41d178688462.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, weight rack, and mirrored walls."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019faa75-ea54-76ac-8a23-b65ae5a84eb1.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of friends celebrating a birthday on a rooftop with a cupcake and candle."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019faa7b-a165-75ff-8723-474af0b83d84.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People enjoying an outdoor event at sunset with food trucks and tents."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[9].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[9].poi_featured_image_media.alt_text"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-40e9-76ae-ac7e-0bcd003c5c9f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog washing station with grooming tub and waste station."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-a8cf-72d4-b92e-15e276c685c1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern lounge area with a large marble fireplace, a TV, and comfortable seating."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-24df-731b-9b0b-33e53c9f6399.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen island with granite countertop, sink, and faucet, overlooking a living area."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_fa4c48c8-b474-4f76-ae2e-62247810906c",
      "custom_19c44128-3b17-41f9-b1e8-d499e3a5a889"
    ],
    "orderedIds": [
      "custom_fa4c48c8-b474-4f76-ae2e-62247810906c",
      "custom_19c44128-3b17-41f9-b1e8-d499e3a5a889",
      "custom_7371619f-2bb0-4e41-8d28-002f6241844b",
      "custom_8254da5d-0f33-4bb6-919f-e6b1f3111e14",
      "custom_4d1a07ce-7657-40c3-acc2-3324bc24e179",
      "custom_40e92e8c-61e7-4f2c-9af2-55222deed77b",
      "custom_9643d191-d163-4a7f-8165-834179d93f50",
      "custom_c689c233-174e-4e88-91fa-0d34beaac8f5",
      "custom_e19a96ab-2af6-43b8-b1c7-0ab6a37f3302",
      "custom_ddb591aa-cbc7-43ca-9704-41ea4703ad0c",
      "custom_8dfd75f7-3ce5-4ce5-8cc4-9fb33c4d7b58",
      "custom_5a00d18d-9e42-4fc1-bcaf-d6c53d9a05b5",
      "custom_8e66b903-951d-4121-b283-f999d7660c75",
      "custom_6c13ad08-622f-4fee-aad0-afb57686803f",
      "custom_74ed5679-df76-4d4c-ad5d-549e31b42382",
      "custom_9f57a9c9-843e-480c-926b-4346f138b78e",
      "custom_81a26d2b-0f9d-427d-bcf0-059af69142a2",
      "custom_31154061-de1a-4f55-aea9-b5b6d2978b2d",
      "custom_106961ab-d64f-46ae-9755-a91e641396bb",
      "custom_050778c0-fa3a-47d1-a097-d6044217f705",
      "custom_f93f0674-7f01-46e2-a942-ee57598120e2",
      "custom_156d8fff-ebbb-416d-b787-7df9c69fda52",
      "custom_56d72f5f-e866-4903-831c-541ba44941fc",
      "custom_91a51234-b368-432a-b0d6-ff61fa5b081e",
      "custom_c69474da-d1e3-4019-8d77-141fccdedd1a",
      "custom_b48f4c4e-094f-4420-944c-284e3fad43d3",
      "custom_accf20a8-df8d-46cf-96cb-a41195fb4285",
      "custom_8b093dc9-6561-4377-8f07-dc9265e988bc",
      "custom_4ecf81b8-aa66-40f3-9511-1874bb04e0eb",
      "custom_4a141be5-583e-4015-9491-53b3122dfc0c",
      "custom_eb655f20-8797-4221-be48-a085b29c40cf",
      "custom_52a178b3-5baa-499b-b050-f832ef4b8964",
      "custom_0c547b8b-8278-47f4-ace4-1185451dc5cf",
      "custom_1a797fae-bd0d-4e3c-a5d2-f1d8e54660a1",
      "custom_61114ea9-c8e1-4e19-b783-ed4aaf08d09e",
      "custom_d2a62b4e-9804-4d76-b296-aa6348fa9f89",
      "custom_a0cd73b4-bbfe-4312-9faf-439ae93bc824",
      "custom_92ab3a35-3b1e-4dba-a3d9-b2a19e833c7d",
      "custom_de502bee-5141-468d-843d-0abdf94c5940",
      "custom_ce4565ec-4aea-44a6-8d34-79e60326d568",
      "custom_892f6a60-5520-4241-b152-90aafeb465c0",
      "custom_9e2eedef-0150-49e0-827f-28afde1f0cd0",
      "custom_bc419412-5066-42de-a454-d6adc756f06a",
      "custom_2efc46a1-6fde-4296-b00f-7f88d0514f8f",
      "custom_bc0bfa75-13ed-4925-b71f-390fd0416acd",
      "custom_27d2b18c-6746-41a0-a531-20854b2210b0",
      "custom_0813fba3-f006-4b55-9557-0d436b8c5614",
      "custom_ded81dc6-667f-4252-8361-3aa72834e355",
      "custom_d3668767-6dad-4388-8b6b-9ba575dd839a",
      "custom_36910cca-18cd-4892-8fde-b8ee67a6ef69",
      "custom_64476658-0a95-4b53-9f68-f6c5e734e18c",
      "custom_f1da6d02-3cc3-4eaf-a993-4832727d3c60",
      "custom_434a07f7-8168-416b-b485-b3c4f8087e75",
      "custom_3921122a-a539-4954-8734-fe0752d48ef3",
      "custom_2982e0df-d7c4-4ec1-8268-e92abd39fe96",
      "custom_0f1d4878-d18e-4e20-8e37-22b222992ada",
      "custom_820b60e3-c4ba-483a-b3a7-f49e1f047b80",
      "custom_8e190711-d9e0-4204-8c8e-f963210f0f44",
      "custom_1d4b5c19-a424-4b96-8c5a-f67f4dbf02fd",
      "custom_f062fa23-dcd7-402e-bd3e-b866624d1c73",
      "custom_6d88d203-7723-46eb-a2b1-ee0046aa81cd",
      "custom_aa6a4932-f1e2-49a0-907d-939428258389"
    ],
    "hiddenIndices": [
      0,
      1
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "contactus.office_hours": {
    "limit": null,
    "hiddenIds": [
      "custom_a92540b9-bdb7-4050-800f-1620497d92ea"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "footer.office_hours": {
    "limit": null,
    "hiddenIds": [
      "custom_a92540b9-bdb7-4050-800f-1620497d92ea"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_fa4c48c8-b474-4f76-ae2e-62247810906c",
      "custom_19c44128-3b17-41f9-b1e8-d499e3a5a889",
      "custom_e19a96ab-2af6-43b8-b1c7-0ab6a37f3302"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      8
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  }
};
